import React from 'react';
import { object } from 'prop-types';
import templateReplace from 'es6-template-strings';
import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';

import { DEFAULT_COLORS } from 'constants/colors';
import { USER_LOOKUP } from 'constants/tickets';

const SubItems = styled.div`
    color: ${DEFAULT_COLORS.BLACK_3};
    font-size: 0.7rem;
    margin: 0.5rem 0 0;
`;

const SubItem = styled.div`
    color: ${DEFAULT_COLORS.BLACK_3};
    font-size: 0.7rem;
    margin: 0.25rem 0 0;
`;

function FullName({ row }) {
    const userId = templateReplace(USER_LOOKUP.NAME.ID, { userId: row?.userId });
    const lastSignIn = templateReplace(USER_LOOKUP.NAME.LAST_SIGN_IN, {
        lastSignIn: row?.lastSignInAt,
    });

    return (
        <Typography wordWrap type="span" fontFamily="Roboto" fontSize="0.875rem">
            <div title={`${row?.firstName} ${row?.lastName}`}>
                {row?.firstName} {row?.lastName}
            </div>
            <SubItems>
                <SubItem>{userId}</SubItem>
                <SubItem>{lastSignIn}</SubItem>
            </SubItems>
        </Typography>
    );
}

FullName.propTypes = {
    row: object,
};

FullName.defaultProps = {
    row: {},
};

export default FullName;
